import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=229a91ee&scoped=true&"
import script from "./HowItWorks.vue?vue&type=script&lang=ts&"
export * from "./HowItWorks.vue?vue&type=script&lang=ts&"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=229a91ee&lang=stylus&scoped=true&"
import style1 from "./HowItWorks.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a91ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
